// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ealY","title":"Info_title__1VrM3","selects":"Info_selects__2vsCh","requiredAsterisk":"Info_requiredAsterisk__16Vz7"};